import * as React from "react";
import { ESG_ELEMENTS } from "./CSRDProgressChart";

function CustomAxisTick({ props, data }) {
  const { value, x, y } = props;

  const getCategoryColor = (topic) => {
    const category = data?.find(el => el.topic === topic)?.category;
    return typeof category !== "undefined" ? ESG_ELEMENTS[category].color : "gray"
  };

  const getCategorySymbol = (topic) => {
    const category = data?.find(el => el.topic === topic)?.category;
    return typeof category !== "undefined" ? ESG_ELEMENTS[category].symbol : "N/A"
  };

  return <g transform={`translate(${x},${y})`}>
    <line
      x1="0" x2="-5" y1="0" y2="0"
      style={{
        stroke: "rgb(119, 119, 119)",
        strokeWidth: 1
      }}>
    </line>
    <circle
      dominantBaseline={"central"}
      textAnchor={"end"}
      transform={"translate(-20,0) rotate(0)"}
      r="9"
      fill={getCategoryColor(value)}
    />
    <text
      transform={"translate(-20,1) rotate(0)"}
      textAnchor="middle" fill="white" fontSize="10px" fontFamily="Arial" dy=".3em"
    >
      {getCategorySymbol(value)}
    </text>
    <text
      id={value}
      fontSize="11px"
      dominantBaseline={"central"}
      textAnchor={"end"}
      transform="translate(-35,0) rotate(0)"
      style={{
        fontFamily: "sans-serif",
        fontSize: "11px",
        fill: "rgb(51, 51, 51)",
        outlineWidth: "0px",
        outlineColor: "transparent",
        backgroundColor: "red",
        fontWeight: "bold"
      }}
    >
      {value.length > 30 ?
        <>
          <title>{value}</title>
          {value.slice(0, 32)}...
        </> :
        value
      }
    </text>
  </g>;
}

export default CustomAxisTick;